const basePath = '/model-viewer';

export class ModelViewerPath {
  static index() {
    return basePath;
  }
}
